<template>
  <div>
  <div class="container">

        <div class="row">Indien je email is gekend in ons systeem en je hebt toekomstige afspraken staan in de agenda dan krijgt u een mail met al je afspraken er in. </div>
        <div class="row"><div class="col-12">&nbsp;</div></div>
        <div class="row">Indien u geen mail hebt ontvangen en je bent zeker dat jouw email gekend is in ons systeem. Controleer in dit geval dan ook eens je spam folder.</div>
         <div class="row"><div class="col-12">&nbsp;</div></div>
            <div class="col-24 contact-btn text-center"> 
                    <div class="product-btn" >
                      <a href="/" v-bind:style="{ 'background-color': getColorApp, color: '#fff'}"><i class="ion-person" ></i>  OK  </a>
                    </div>
            </div>  
          
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import CartItem  from '../components/cart/CartItem';
  export default {
    name: 'product-list',
    props: ['products'],
    data () {
      return {
        selTime: Vue.$selectedTime,
        cart: this.$store.state.cart,
        flgShowDet : false
      }
    },
    components: {
        cartItem : CartItem
    },
    mounted () {

    },
    computed: {
      getColorApp () {
           return Vue.$storeSettings.ColorApp;
       }
    },
    methods: {
       navigate (item) {
        this.$router.push(item);
      },
      navigateBack () {
        this.$router.go(-1);
      },
      resetAppoint () {
         Vue.$selectedTime = {}
         this.navigate ('/');
      }
    }
  }
</script>
<style>
  .products {
    background: #F7F8FB;
    padding: 30px 0;
  }
  @media (max-width: 800px) {
      .hidesmall {
        display: none;
      }
  }
</style>



// WEBPACK FOOTER //
// src/pages/MyAccountSend.vue